/* eslint-disable no-param-reassign */
import FeatureManager from '@/services/featureManager';

const state = {
  enabledFeatures: {},
};

const getters = {
  enabledFeatures: currentState => currentState.enabledFeatures,
};

const actions = {
  loadEnabledFeatures: async ({ commit }) => {
    FeatureManager.loadTemporaryFeatures();
    const enabledFeatures = FeatureManager.getEnabledFeatures();
    commit('setEnabledFeatures', enabledFeatures);
  },
};

const mutations = {
  setEnabledFeatures: (currentState, enabledFeatures) => {
    currentState.enabledFeatures = enabledFeatures;
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
